<template>
  <div class="context">
    <div class="cardheard">
      <div>
        <el-input placeholder="请输入姓名/手机号" v-model="req.parma" />
      </div>
      <div>
        <el-date-picker
      v-model="value1"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
      </div>
      <el-button type="primary" @click="selectByQuery">查询</el-button>
      <el-button type="primary" @click="clear">清空</el-button>
    </div>
    <template>
      <el-table v-model="orders" :data="orders" style="width: 100%" height="80%" v-loading="loading">
        <el-table-column type="index" width="50">
        </el-table-column>

        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.checkPersonName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="房间类型">
          <template slot-scope="scope">
            <span>{{ scope.row.homeTypeName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="房间号">
          <template slot-scope="scope">
            <span>{{ scope.row.homeNum }}</span>
          </template>
        </el-table-column>

        <el-table-column label="入住时长">
          <template slot-scope="scope">
            <span>{{ scope.row.continued+scope.row.startDays }}</span>
          </template>
        </el-table-column>

        <el-table-column label="入住时间" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

        <el-table-column label="退房时间" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.timeEnd }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="300">

          <template slot-scope="scope">
            <el-button type="text" @click="updateUser(scope.row)" size="small">修改</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <div slot="footer" class="dialog-footer">
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="10000">
          </el-pagination>
        </div>
      </div>


    </template>
    <template>
    </template>

    <div v-if="modelShow">
      <UserUpdateorAdmin :dialogShow="modelShow" ref="userModel" @pushdata="pushdata"  @modelChange="userShowChange" />
    </div>
  </div>
</template>

<script>
import store from '@/store/'
import UserUpdateorAdmin from '../components/userUpdateorAdmin.vue'

export default {
  data() {
    return {
      value1: '',
      value2: '',
      loading:true,
      req: {
        parma: "",
        pageIndex: 0,
        pageCount: 3,
        query: {
          sysUserId: 1,
          timeStart:"",
          timeEnd:""
        },
      },
      orders: [],
      modelShow: false
    };
  },
  mounted() {
    this.req.sysUserId = this.$store.state.user.user.id;
    this.pushdata();
  },
  methods: {
    reset() {
      this.req.pageIndex=0
      this.req.pageCount=10
    },
    clear(){
      this.req.parma=""
      this.req.query.timeStart=""
      this.req.query.timeEnd=""
      this.value1=""
      this.reset()
      this.pushdata()
    },
    selectByQuery() {
      this.req.pageIndex = 0;
      this.pushdata();
    },
    updateUser(row) {
      this.modelShow = true,
        setTimeout(() => {
          this.$refs['userModel'].init(row.id)//用$refs赋值调用子组件的init方法
        }, 500)
    },
    userShowChange(visible){
      this.modelShow=visible
    },
     formatDate(d){
        var date = new Date(d);
        var YY = date.getFullYear() + "-";
        var MM =
            (date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1) + "-";
        var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hh =
            (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        var mm =
            (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
            ":";
        var ss =
            date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return YY + MM + DD + " " + hh + mm + ss;
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      }
      else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    pushdata() {
      var that = this;
      if(that.value1!=""){
      console.log(that.value1)
      var time1=that.formatDate(that.value1[0])
      var time2=that.formatDate(that.value1[1])
      console.log(time1)
      that.req.query.timeStart=time1.split(' ')[0].concat(" 00:00:00")
      that.req.query.timeEnd=time2.split(' ')[0].concat(" 23:59:59")
      }

      that.$axios
        .post("/api2/business/getHisCheckOrderByTime", this.req)
        .then(function (response) {
          that.loading=false
          that.orders = response.data.data;
        });
    }
  },
  components: { UserUpdateorAdmin }
}
</script>
<style scoped></style>
